import React from 'react';
var EntityInfo = function (_a) {
    var entity = _a.entity, ssnText = _a.ssnText, testId = _a.testId;
    return (React.createElement("div", { "data-testid": "".concat(testId, "-").concat(entity.ssn, "-entityInfo") },
        React.createElement("div", null, entity.name),
        React.createElement("div", null,
            " ", "".concat(ssnText, " ").concat(entity.ssn))));
};
export default EntityInfo;
//# sourceMappingURL=EntityInfo.js.map